/* istanbul ignore file */
import { ContentStatus } from 'src/app/shared/enums/content-status';
import { IDynamicData } from './interfaces/i-dynamic-data';
import { IPageContentDto } from './interfaces/i-page-content-dto';
import { IVideoMediaDto } from './interfaces/i-video-media-dto';
import { IImgMediaDto } from './interfaces/i-img-media-dto';

export class PageContentDto implements IPageContentDto {
  public id!: string;
  public cas!: string;
  public contentId!: string;
  public headline!: string;
  public standfirst!: string;
  public body!: string;
  public bodyImages!: IImgMediaDto[];
  public bodyVideos!: IVideoMediaDto[];
  public deliveryTargetCodes: string[];
  public languageCode: string;
  public status!: ContentStatus;
  public lastUpdatedDate!: Date;
  public createdDate!: Date;
  public publishedDate!: Date;
  public dynamicData!: IDynamicData;
  public lastUpdatedByUser!: string;
  public isPublished: () => boolean;
  public isCurrentLiveVersion: () => boolean;
  constructor({
    id,
    cas,
    contentId,
    headline,
    standfirst,
    body,
    bodyImages,
    bodyVideos,
    deliveryTargetCodes,
    languageCode,
    status,
    lastUpdatedDate: lastUpdatedDate,
    createdDate,
    publishedDate,
    dynamicData,
    lastUpdatedByUser,
  }: IPageContentDto) {
    this.id = id;
    this.cas = cas;
    this.contentId = contentId;
    this.headline = headline;
    this.standfirst = standfirst;
    this.body = body;
    this.bodyImages = bodyImages ?? [];
    this.bodyVideos = bodyVideos ?? [];
    this.deliveryTargetCodes = deliveryTargetCodes ?? [];
    this.languageCode = languageCode;
    this.status = status;
    this.lastUpdatedDate = lastUpdatedDate;
    this.createdDate = createdDate;
    this.publishedDate = publishedDate;
    this.dynamicData = { ...dynamicData };
    this.lastUpdatedByUser = lastUpdatedByUser;

    this.isPublished = () => this.status === ContentStatus.PUBLISHED;
    this.isCurrentLiveVersion = () =>
      this.id === this.dynamicData?.latestPublishedVersionId;
  }
}
